export const DISTRIBUTIONS = 'DISTRIBUTIONS';
export const LINEAR_MODEL_FORM = 'LINEAR_MODEL_FORM';
export const BOOTSTRAP_CIS_FORM = 'BOOTSTRAP_CIS_FORM';
export const INFERENTIAL_STATISTICS = 'INFERENTIAL_STATISTICS';
export const SAMPLING_DISTRIBUTIONS_FORM = 'SAMPLING_DISTRIBUTIONS_FORM';
export const RANDOMIZATION_HYPOTHESIS_TESTING_FORM = 'RANDOMIZATION_HYPOTHESIS_TESTING_FORM';
